export default __webpack_public_path__ + "static/ramengo-f6f6aea48722c8d47870517f65649e9b.png";